import React from "react";
import "./Carousel.css";

const Carousel = ({ images }) => {
  // If no images provided, use default images
  const defaultImages = [
    `${process.env.PUBLIC_URL}/wtm-hero-1.jpg`,
    `${process.env.PUBLIC_URL}/wtm-hero-2.jpg`,
    `${process.env.PUBLIC_URL}/wtm-hero-3.jpg`,
    `${process.env.PUBLIC_URL}/porsche-placeholder.avif`,
  ];

  const carouselImages = images || defaultImages;

  return (
    <div className="smooth-carousel-container mt-16 mb-0">
      <div className="smooth-carousel-track">
        {/* Just duplicate once for seamless loop */}
        {[...carouselImages, ...carouselImages].map((image, index) => (
          <div key={index} className="smooth-carousel-slide">
            <img
              src={image}
              alt={`Carousel image ${index + 1}`}
              className="smooth-carousel-image"
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default Carousel;
